import React from 'react';
import StatsCard from './StatsCard';
import { formatMoney, numberFormat } from '../../util/araknerdlib';
import { SkeletonStatCard } from '../../util/skeleton/Skeleton';
import { useAuth } from '../../DataStore/AuthContext';

/**
 * StatsCardRow
 * - revenueTrends is null while loading
 * - expected shape once loaded:
 *   {
 *     revenueToday: number,
 *     revenueThisMonth: number,
 *     trendToday: { direction, numeric, value, color },
 *     trendMonth: { direction, numeric, value, color }
 *   }
 */
const StatsCardRow = ({ revenueTrends }) => {

  const {connectedProfiles} = useAuth();
  // Loading state: show skeletons
  if (!revenueTrends) {
    return (
      <>
      <div className="col-sm-6 col-xl-6 col-lg-6">
        <SkeletonStatCard />
      </div>
      <div className="col-sm-6 col-xl-6 col-lg-6">
        <SkeletonStatCard />
    </div>
      </>
    );
  }

  // Safeguard + formatting
  const {
    revenueToday = 0,
    revenueThisMonth = 0,
    trendToday = { direction: 'flat', value: '0.0%', color: 'text-muted' },
    trendMonth = { direction: 'flat', value: '0.0%', color: 'text-muted' },
  } = revenueTrends || {};


  return (
    <>
      <StatsCard
        title="Revenue Today"
        icon="fas fa-chart-line"
        iconColor="text-success"
        value={`${numberFormat(revenueToday)}`}
        progressPercent={60}
        progressColor="bg-success"
        trend={trendToday}
        preValue={connectedProfiles?.currency}
      />
      <StatsCard
        title="Revenue This Month"
        icon="fas fa-chart-line"
        iconColor="text-info"
        value={`${numberFormat(revenueThisMonth)}`}
        progressPercent={90}
        progressColor="bg-info"
        trend={trendMonth}
        preValue={connectedProfiles?.currency}
      />
    </>
  );
};

export default StatsCardRow;
